<template>
	<el-container id="course_selection">
        <div class="con">
            <!-- <leftbox></leftbox> -->
            <coursesele></coursesele>
        </div>
    </el-container>
</template>
<script>
import leftbox from '@/components/leftBox.vue'
import coursesele from '@/components/dyy_assembly/courseSele.vue'
export default {
	name: 'course_selection'
    ,components:{
        leftbox,
        coursesele
    }
	,data () {
		return {
		}
	}
	,mounted:function(){
	}
	,watch:{
	}
	,computed:{
        
	}
	,methods:{
	}
	,destroyed:function(){
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/course_selection.vue